export default {
    namespaced: true,
    state: {
        currentUser: null,
    }
}